// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GcsBucketIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="url(#gcs-bucket_svga)"
      d="M10.42 43.57.58 26.52a4.3 4.3 0 0 1 0-4.31l9.84-17.05A4.3 4.3 0 0 1 14.16 3h19.68a4.3 4.3 0 0 1 3.74 2.16l9.84 17.05a4.3 4.3 0 0 1 0 4.3l-9.84 17.06a4.3 4.3 0 0 1-3.74 2.15H14.16a4.3 4.3 0 0 1-3.74-2.15"
    />
    <mask
      id="gcs-bucket_svgb"
      width={48}
      height={43}
      x={0}
      y={3}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M10.42 43.57.58 26.52a4.3 4.3 0 0 1 0-4.31l9.84-17.05A4.3 4.3 0 0 1 14.16 3h19.68a4.3 4.3 0 0 1 3.74 2.16l9.84 17.05a4.3 4.3 0 0 1 0 4.3l-9.84 17.06a4.3 4.3 0 0 1-3.74 2.15H14.16a4.3 4.3 0 0 1-3.74-2.15"
      />
    </mask>
    <g mask="url(#gcs-bucket_svgb)">
      <path
        fill="#000"
        d="m18.48 20.57-2.63 2.62 2.24 2.23-2.22 3.93 16.74 16.74h4.06l7.92-14.23-12.54-12.54z"
        opacity={0.07}
      />
    </g>
    <path
      fill="#fff"
      d="M31.76 19.21H16.22c-.25 0-.45.2-.45.46v3.21c0 .25.2.46.45.46h15.54c.25 0 .45-.2.45-.46v-3.21c0-.25-.2-.46-.45-.46m-2.4 3a.93.93 0 1 1 0-1.87.93.93 0 0 1 0 1.86m2.4 3.18H16.22c-.25 0-.45.2-.45.45v3.22c0 .25.2.45.45.45h15.54c.25 0 .45-.2.45-.45v-3.22c0-.25-.2-.45-.45-.45m-2.4 2.99a.93.93 0 0 1 0-1.86.93.93 0 1 1 0 1.86"
    />
    <defs>
      <linearGradient
        id="gcs-bucket_svga"
        x1={24}
        x2={24}
        y1={3}
        y2={45.66}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4387FD" />
        <stop offset={1} stopColor="#4683EA" />
      </linearGradient>
    </defs>
  </svg>,
  "GcsBucket",
);
export default GcsBucketIcon;
